// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .custom-overlay-panel {
  left: 15px !important;
  top: 55px !important;
}

::ng-deep .custom-overlay-panel-toggle-btn {
  background: transparent !important;
  border: none !important;
}
::ng-deep .custom-overlay-panel-toggle-btn:hover {
  background: transparent;
  border: none;
}

.content {
  overflow-y: scroll;
  height: 255px;
}

.clickable-options {
  display: flex;
  padding: 10px;
}
.clickable-options.selected {
  opacity: 1 !important;
  background: #386FA4 !important;
  color: white !important;
}
.clickable-options.selected ::ng-deep .btn-set-default .pi-circle-off {
  color: white !important;
}
.clickable-options .btn-set-default {
  flex: 0 0 20px;
}
.clickable-options ::ng-deep .btn-set-default .pi-circle-on {
  color: orange !important;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
